<template>
    <div v-if="selectedMapAreaIndex_n != null">
        <!-- map -->
        <tq-on-top-container>
            <tq-leaflet-display
                slot="body"
                :key="'refresh_' + refreshMapCounter_n"
                class="TQ_height_bodyHalfScreen TQ_bg_white lc_leaflet"
                :style="{height : p_mapHeight_s}"

                :pb_map-uid_s="$options.name"
                :p_display_lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"

                :p_map-data_c="p_questBody_c.qb_mapData_c"
                :p_polygons_ac="co_mapPolygons_ac"

                :p_players-location_by-user-id_c="p_playersLocation_byUserId_c"
                :p_current-user-location_c="p_currentUserLocation_c"

                :p_missions_ac="p_questBody_c.qb_mapMissions_ac"
                :p_map-mission-type_e="p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e"

                :pe_click-polygon_f="m_click_polygon_f"

                :pf_two-fingers-movement_b="true"

                :pe_start-watch-position_f="pe_startWatchPosition_f"
                :pe_stop-watch-position_f="pe_stopWatchPosition_f"
            />

            <!-- points bar -->
            <tq-stating-points-bar
                    slot="topLeft"
                    class="lc_pointsBar TQ_height_bodyHalfScreen TQ_borderBox TQ_padding_8px"
                    :style="{height : p_mapHeight_s}"

                    :p_total-points_n="m_getAreaTotalPoints_fn(selectedMapAreaIndex_n)"
                    :p_current-points_n="m_getAreaCurrentPoints_fn(selectedMapAreaIndex_n)"
                    :p_finish-line1-points_n="p_questBody_c.qb_mapMissionsGroup_ac[selectedMapAreaIndex_n].qbmg_pointsToUnlock_n"
            />

        </tq-on-top-container>

        <!-- mission list-->
        <div class="TQ_bg_white TQ_grid_gap_8px TQ_padding_8px TQ_grid_col_1fr1fr TQ_borderBox" :key="'b_' + selectedMapAreaIndex_n" >

            <div v-for="(riddleId_n) in p_questBody_c.qb_mapMissionsGroup_ac[selectedMapAreaIndex_n].qbmg_riddlesIds_an"
                 class="TQ_clickable"
                 @click="pe_clickMission_f(riddleIndex_byRiddleId_n[riddleId_n])">

                <tq-on-top-container>

                    <!--<tq-image slot="body" class="TQ_borderRadius TQ_width_100p TQ_box_shadow"-->
                              <!--:pb_src_r="m_getRiddleData_f(riddleId_n).qbr_imgFile_blc_c[co_displayLangCode_e].fi_url_s"/>-->

                    <tq-img-fill-blur p_height_s="150px"
                                      slot="body"
                                      class="TQ_width_100p TQ_box_shadow "
                                      p_image-class_s="TQ_borderRadius"
                                      :pp_img-url_s="m_getRiddleData_f(riddleId_n).qbr_imgFile_blc_c[co_displayLangCode_e].fi_url_s"/>

                    <tq-image slot="topLeft"
                              v-if="m_finishLock_b(riddleId_n)"
                              :src="ass_img_checked"
                              class="TQ_width_24px TQ_bg_circle TQ_border_white_2px TQ_margin_4px"/>


                    <div slot="bottomRight"
                         :class="m_finishLock_b(riddleId_n) ? 'TQ_bg_green_tra' : 'TQ_bg_purple_a'"
                         class="lc_pointsLabel TQ_borderBox TQ_bold  TQ_padding_4px TQ_text_14px TQ_textColor_white">
                        <div class="TQ_inline">
                            <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                        </div>
                        <div class="TQ_padding_1px TQ_inline TQ_verticalAlignMiddle"></div>
                        <div class="TQ_verticalAlignMiddle TQ_inline TQ_text_20px"> {{m_getRiddleData_f(riddleId_n).cm_gbr_totalPoints_n()}} </div>
                    </div>

                </tq-on-top-container>

            </div>
        </div>

    </div>
</template>

<script>
    import TqLeafletDisplay from "../maps/TqLeafletDisplay";
    import TqStatingPointsBar from "../basic/tqStandingPointsBar";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqImage from "../basic/TqImage";
    import {notification_notify} from "../../scripts/S_Notification";
    import {validator_enum_fb, validator_objTypeof_fb, validator_objClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_langCodes,
        enum_subCollection_teamStatus,
        enum_typeof
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {ass_img_checked, ass_img_oneStar_w} from "../../assets/scripts/Ass_Files";
    import TqImgFillBlur from "../basic2/TqImgFillBlur";
    import {helper_finishRiddle_fb} from "../../scripts/S_Helper";
    import {FB_QuestBody, FB_RiddleStatus} from "../../../functions/src/shareCode/Share_S_Classes";
    export default {
        name: "TqPolygonsMapMissions",
        components: {TqImgFillBlur, TqImage, TqOnTopContainer, TqStatingPointsBar, TqLeafletDisplay},
        props:{
            p_questBody_c :{
                type: FB_QuestBody,
                require:true
            },
            p_system_langCode_e : {
                type : String,
                require : true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_currentPoints_byRiddleId_n:{
                type : Object,
                require : true,
                validator(val){
                    return validator_objTypeof_fb(val, enum_typeof.number)
                }
            },
            p_riddlesStatus_byRiddleId_n:{
                type : Object,
                require : true,
                validator(val){
                    return validator_objClass_fb(val, FB_RiddleStatus)
                }
            },
            p_mapHeight_s:{
                type: String
            },
            p_gst_missionsArrangementIndex_n:{
                type: Number,
                require: true,
            },

            // functions
            pe_clickMission_f:{
                type : Function,
                require: true,
            },

            // pass to child components
            p_playersLocation_byUserId_c :{},
            p_currentUserLocation_c:{},
            pe_startWatchPosition_f: {},
            pe_stopWatchPosition_f: {},
        },
        data(){
            return {
                selectedMapAreaIndex_n : null,
                refreshMapCounter_n : 0,

                mapOpenAreas_byAreaIndex_b : {},
                riddleIndex_byRiddleId_n : {},
                missionTotalPoints_byRiddleId_n : {},

                // imports
                ass_strings :ass_strings,
                ass_img_oneStar_w :ass_img_oneStar_w,
                ass_img_checked :ass_img_checked,
            }
        },
        computed:{
            co_mapPolygons_ac(){
                if(this.p_questBody_c == null){
                    return []
                }
                return this.p_questBody_c.qb_mapData_c.md_polygons_ac.map((md_polygon_c,polygonIndex_n) => {

                    let indexOfMapAreas_n = this.co_mapAresOrderIndexes_an.indexOf(polygonIndex_n)

                    if(indexOfMapAreas_n < 0 ){
                        md_polygon_c.mdp_color_s = 'purple'
                        md_polygon_c.mdp_strokeWidth_n = 0
                        md_polygon_c.mdp_fillOpacity_n = 0
                        md_polygon_c.mdp_name_s = null
                    } else if(polygonIndex_n === this.selectedMapAreaIndex_n) {
                        md_polygon_c.mdp_color_s = 'purple'
                        md_polygon_c.mdp_strokeWidth_n = 2
                        md_polygon_c.mdp_fillOpacity_n = 0.3
                        md_polygon_c.mdp_name_s = '' + (indexOfMapAreas_n + 1)
                    }else if(this.m_mapAreaOpen_fb(polygonIndex_n)){
                        md_polygon_c.mdp_color_s = 'green'
                        md_polygon_c.mdp_strokeWidth_n = 1
                        md_polygon_c.mdp_fillOpacity_n = 0.3
                        md_polygon_c.mdp_name_s = '' + (indexOfMapAreas_n + 1)
                    }else{
                        md_polygon_c.mdp_color_s = 'red'
                        md_polygon_c.mdp_strokeWidth_n = 0.7
                        md_polygon_c.mdp_fillOpacity_n = 0.3
                        md_polygon_c.mdp_name_s = '' + (indexOfMapAreas_n + 1)
                    }

                    return md_polygon_c
                }).filter(item => {return item != null})

            },
            co_displayLangCode_e(){
                return this.p_questBody_c.cm_qb_getDisplayLangCode_e(this.p_system_langCode_e)
            },
            co_defaultMapAresOrderIndexes_an(){

                if(this.p_questBody_c == null){
                    return [0]
                }

                return this.p_questBody_c.qb_mapMissionsGroup_ac.map((val,index_n) => {return index_n})
            },
            co_mapAresOrderIndexes_an(){

                let currentTeam_missionsArrangement_c = this.p_questBody_c.qb_missionsArrangements_ac[this.p_gst_missionsArrangementIndex_n]

                return currentTeam_missionsArrangement_c.qbma_groupsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.MAP_MISSIONS]
            },
        },
        methods: {
            m_getRiddleData_f(riddleId_n){
                return this.p_questBody_c.qb_mapMissions_ac[this.riddleIndex_byRiddleId_n[riddleId_n]]
            },
            m_click_polygon_f(polygonIndex_n){

                if(this.co_mapAresOrderIndexes_an.indexOf(polygonIndex_n) < 0){
                    return
                }

                if(!this.m_mapAreaOpen_fb(polygonIndex_n)){
                    notification_notify(ass_strings.fourWords_theAreaIsLocked)
                    return
                }
                this.selectedMapAreaIndex_n = polygonIndex_n
                this.selectedRiddleIndex_n = null
            },
            m_mapAreaOpen_fb(mapAreaIndex_n){

                let orderMapAreasIndex_an = this.co_mapAresOrderIndexes_an


                let currentIndex_n = orderMapAreasIndex_an.indexOf(mapAreaIndex_n)
                let prevIndex_n = orderMapAreasIndex_an[currentIndex_n-1]

                if(currentIndex_n < 0 ){
                    return false
                }

                // first index
                if(currentIndex_n === 0){
                    return true
                }

                if(this.mapOpenAreas_byAreaIndex_b[prevIndex_n]){
                    return true
                }

                this.mapOpenAreas_byAreaIndex_b[prevIndex_n] = this.p_questBody_c.qb_mapMissionsGroup_ac[prevIndex_n].qbmg_pointsToUnlock_n <= this.m_getAreaCurrentPoints_fn(prevIndex_n)
                return this.mapOpenAreas_byAreaIndex_b[prevIndex_n]

            },
            m_getAreaCurrentPoints_fn(mapAreaIndex_n){

                let ans_n = 0
                this.p_questBody_c.qb_mapMissionsGroup_ac[mapAreaIndex_n].qbmg_riddlesIds_an.forEach(riddleId_n => {
                    
                    ans_n += this.p_currentPoints_byRiddleId_n[riddleId_n] ? this.p_currentPoints_byRiddleId_n[riddleId_n] : 0
                })

                return ans_n
            },
            m_getAreaTotalPoints_fn(mapAreaIndex_n){

                let ans_n = 0
                this.p_questBody_c.qb_mapMissionsGroup_ac[mapAreaIndex_n].qbmg_riddlesIds_an.forEach(riddleId_n => {
                    ans_n += this.missionTotalPoints_byRiddleId_n[riddleId_n] ? this.missionTotalPoints_byRiddleId_n[riddleId_n] : 0
                })


                return ans_n
            },
            m_finishLock_b(riddleId_n){


                return helper_finishRiddle_fb( this.m_getRiddleData_f(riddleId_n), this.p_riddlesStatus_byRiddleId_n[riddleId_n])

                // return this.m_getRiddleData_f(riddleId_n).cm_gbr_totalPoints_n() === this.p_currentPoints_byRiddleId_n[riddleId_n]
            }
        },
        activated(){
            // this.refreshMapCounter_n++
        },
        created(){

            this.selectedMapAreaIndex_n = this.co_mapAresOrderIndexes_an[0]

            this.p_questBody_c.qb_mapMissions_ac.forEach((qb_riddle_c, index_n) => {
                this.riddleIndex_byRiddleId_n[qb_riddle_c.qbr_riddleId_n] = index_n

                this.missionTotalPoints_byRiddleId_n[qb_riddle_c.qbr_riddleId_n] =  qb_riddle_c.cm_gbr_totalPoints_n();


            })
        }
    }
</script>

<style scoped>
    .lc_pointsLabel{
        margin-bottom: 8px;
        border-top: 1px solid white;
        border-left: 1px solid white;
        border-bottom: 1px solid white;
        border-radius: 4px 0 0 8px;
    }
</style>